import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.GET_BULK_PAYMENT_TEMPLATE_START:
      return {
        ...state,
        bulkPaymentTemplate: {
          ...state.bulkPaymentTemplate,
          loading: true,
          error: null,
        },
      };
    case ActionType.GET_BULK_PAYMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        bulkPaymentTemplate: {
          ...state.bulkPaymentTemplate,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.GET_BULK_PAYMENT_TEMPLATE_ERROR:
      return {
        ...state,
        bulkPaymentTemplate: {
          ...state.bulkPaymentTemplate,
          data: payload,
          error: null,
          loading: false,
        },
      };

    default:
      return null;
  }
};
